import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import RequestModal from '../components/RequestModal';
export default function addRequestSetting() {
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    const canRequestUsername = app.forum.attribute('canRequestUsername');
    if (!canRequestUsername) return;
    items.add('username-request', m(Button, {
      className: "Button",
      onclick: () => app.modal.show(RequestModal)
    }, app.translator.trans('fof-username-request.forum.settings.username_request_button')));
  });
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    if (!app.initializers.has('flarum/nicknames')) return;
    if (app.forum.attribute('displayNameDriver') !== 'nickname') return;
    if (!app.forum.attribute('canRequestNickname')) return;
    items.add('nickname-request', m(Button, {
      className: "Button",
      onclick: () => app.modal.show(RequestModal, {
        nickname: true
      })
    }, app.translator.trans('fof-username-request.forum.settings.nickname_request_button')));
  });
}
flarum.reg.add('fof-username-request', 'forum/extenders/addRequestSetting', addRequestSetting);